angular.module('unica_event.event_controllers')

.controller('EventSiteController',
	function(
		$rootScope, $scope, $state, $stateParams, $timeout,
		$confirm, FileUploader, getBaseApiURL, Session, $window,
		EventSiteService
	) {

	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $scope.event_id );

	$scope.$on('event_loaded', function() {
		$scope.checkPreviewSite();
	});

	$scope.uploader = new FileUploader({
		autoUpload: true,
		removeAfterUpload: true,
		alias: 'event_program',
		url: getBaseApiURL + '/event/update-event-program/' + $scope.event_id,
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});


	$scope.uploader.onCompleteItem = function(fileItem, response)
	{
		if (!response.error && response.event) {
			$rootScope.eventData = response.event;
		} else {
			$rootScope.manageError(response);
		}

	};

	$scope.changeEventFeaturedImage = function()
	{
		$rootScope.eventData.featured_image_changed = true;
		$scope.uploader.formData.push({ 'featured_image_changed' : $rootScope.eventData.featured_image_changed });
	};

	$scope.changeEventFeaturedImageMobile = function()
	{
		$rootScope.eventData.featured_image_mobile_changed = true;
		$scope.uploader.formData.push({ 'featured_image_mobile_changed' : $rootScope.eventData.featured_image_mobile_changed });
	};

	$scope.changeEventProgram = function()
	{
		$rootScope.eventData.program_changed = true;
		$scope.uploader.formData.push({ 'program_changed' : $rootScope.eventData.program_changed });
	};

	$scope.checkSiteForm = function()
	{
		if ( !$scope.forms.site_form.$invalid &&
			$rootScope.eventData &&
			$rootScope.eventData.cover && $rootScope.eventData.cover.dataURL != '' ) {
			return false;
		}
		return true;
	};

	$scope.changeHideLocation = function()
	{
		$scope.eventData.hide_map = $scope.eventData.hide_location;
		$scope.eventData.hide_address = $scope.eventData.hide_location;
	}

	$scope.changeHideMapOrAddress = function()
	{
		//$scope.eventData.hide_location = ( $scope.eventData.hide_map && $scope.eventData.hide_address);
	}

	$scope.saveSite = function()
	{
		$scope.showLoader();

		if ( $rootScope.eventData.cover && $rootScope.eventData.cover.dataURL ) {
			$rootScope.eventData.cover = $rootScope.eventData.cover.dataURL;
		}

		if ( $rootScope.eventData.logo && $rootScope.eventData.logo.dataURL ) {
			$rootScope.eventData.logo = $rootScope.eventData.logo.dataURL;
		} else {
			$rootScope.eventData.logo = '';
		}

		if ( $rootScope.eventData.featured_image && $rootScope.eventData.featured_image.dataURL ) {
			$rootScope.eventData.featured_image = $rootScope.eventData.featured_image.dataURL;
		} else {
			$rootScope.eventData.featured_image = '';
		}

		if ( $rootScope.eventData.featured_image_mobile && $rootScope.eventData.featured_image_mobile.dataURL ) {
			$rootScope.eventData.featured_image_mobile = $rootScope.eventData.featured_image_mobile.dataURL;
		} else {
			$rootScope.eventData.featured_image_mobile = '';
		}

		var eventData = angular.copy($rootScope.eventData);

		EventSiteService
			.updateSite( $stateParams.event_id, eventData)
			.then(function() {
				$scope.hideLoader();

				$rootScope.getEvent( $scope.event_id );

				$scope.showSuccessMsg('Sito aggiornato con successo!', '');
				$state.go('saveSite', { id: $rootScope.eventData.id });
		});
	};


	$scope.removeSiteCover = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'immagine di copertina del sito?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			EventSiteService
				.deleteSiteCover( $stateParams.event_id  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data) {

						$rootScope.getEvent( $scope.event_id );
						$rootScope.eventData.cover = null;

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Immagine Sito eliminata con successo!', '');
					}
				});

		}, function() { });
	};


	$scope.removeSiteLogo = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare il logo del sito?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			EventSiteService
				.deleteSiteLogo( $stateParams.event_id  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						$rootScope.getEvent( $scope.event_id );
						$rootScope.eventData.logo = null;

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Logo Sito eliminato con successo!', '');
					}
				});

		}, function() { });
	};


	$scope.removeEventFeaturedImage = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'immagine in evidenza?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			EventSiteService
				.deleteFeaturedImage( $stateParams.event_id  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						$rootScope.getEvent( $scope.event_id );
						$rootScope.eventData.featured_image = null;

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Immagine rimossa con successo!', '');
					}
				});

		}, function() { });
	};


	$scope.removeEventFeaturedImageMobile = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'immagine in evidenza APP?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			EventSiteService
				.deleteFeaturedImageMobile( $stateParams.event_id  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						$rootScope.getEvent( $scope.event_id );
						$rootScope.eventData.featured_image_mobile = null;

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Immagine APP rimossa con successo!', '');
					}
				});

		}, function() { });
	};


	$scope.removeEventProgram = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare il programma dell\'evento dal sito?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			EventSiteService
				.deleteEventProgram( $stateParams.event_id  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$rootScope.eventData.program = null;

						$scope.showSuccessMsg('Programma eliminato con successo!', '');
					}
				});

		}, function() { });
	};


	$scope.previewUrl = '#';


	$scope.checkPreviewSite = function()
	{
		$scope.showLoader();

		EventSiteService
			.checkSitePreview( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.previewUrl = data.url;
				}
			});
	};

});
